import { memo } from 'react';
import { FlutedGlass } from '@paper-design/shaders-react';

const FLUTED_GLASS_CONTEXT_ATTRIBUTES = {
  alpha: true,
  antialias: false,
  depth: false,
  stencil: false,
  premultipliedAlpha: true,
  preserveDrawingBuffer: false,
  powerPreference: 'low-power'
};

const HomeFlutedGlass = memo(function HomeFlutedGlass({
  className = '',
  image,
  maxPixelCount = 360000,
  ...elementProps
}) {
  return (
    <FlutedGlass
      {...elementProps}
      className={`home-fluted-glass ${className}`.trim()}
      aria-hidden="true"
      width="100%"
      height="100%"
      image={image}
      colorBack="#00000000"
      colorShadow="#000000"
      colorHighlight="#ffffff"
      size={0.4}
      shadows={0.4}
      highlights={0}
      shape="lines"
      angle={0}
      distortionShape="cascade"
      distortion={0.75}
      shift={0}
      stretch={0}
      blur={0.25}
      edges={0}
      margin={0.1}
      grainMixer={0}
      grainOverlay={0}
      speed={0}
      frame={0}
      scale={1}
      fit="cover"
      minPixelRatio={1}
      maxPixelCount={maxPixelCount}
      webGlContextAttributes={FLUTED_GLASS_CONTEXT_ATTRIBUTES}
    />
  );
});

export default HomeFlutedGlass;
